import { render, staticRenderFns } from "./OrganizationEditDetails.vue?vue&type=template&id=3ee0bbe4&scoped=true&"
import script from "./OrganizationEditDetails.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee0bbe4",
  null
  
)

export default component.exports